//注册vue全局组件
import Vue from "vue"
import { Carousel, CarouselItem, Transfer, Tree, Loading } from "element-ui"

Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Transfer)
Vue.use(Tree)
Vue.use(Loading)
